<template>
  <div class="wt-asset-gallery-modal">
    <asset-gallery ref="assetGallery" :closeModal="closeModal" />
  </div>
</template>

<script>
import AssetGallery from 'v/AssetGallery.vue';

export default {
  components: { 'asset-gallery': AssetGallery },

  props: {
    closeModal: {
      type: Function,
    },
  },

  mounted() {
    this.$refs.assetGallery.show();
  },
};
</script>
